export enum LocationType {
  PICK_UP = 'pickUp',
  DROP_OFF = 'dropOff',
}

export enum CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS {
  PICK_UP_LOCATION = 'pickUpLocation',
  PICK_UP_LOCATION_NAME = 'pickUpLocationName',
  PICK_UP_DATE = 'pickUpDate',
  PICK_UP_TIME = 'pickUpTime',
  PROVIDERS = 'providers',
  DROP_OFF_LOCATION = 'dropOffLocation',
  DROP_OFF_LOCATION_NAME = 'dropOffLocationName',
  DROP_OFF_DATE = 'dropOffDate',
  DROP_OFF_TIME = 'dropOffTime',
}

export const CAR_RENTAL_LISTING_DEFAULT_PAGE = 1;
export const CAR_RENTAL_LISTING_DEFAULT_LIMIT = 20;
